// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import archive from './routes/archive';
import singleProduct from './routes/singleProduct';
import templateContact from './routes/templateContact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Archive products
  archive,
  // Single product
  singleProduct,
  // Contact
  templateContact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js